/**
 * Buyer-facing "repriced for quote/checkout" affordance copy (UID-139,
 * ADR-0061 Decision 4; narrowed by the ADR-0061 UID-419 amendment).
 *
 * ADR-0061 Decision 4 originally called for a short, non-silent disclosure note
 * on each of the cart / Generate-quote / checkout money surfaces, wherever the
 * cart's indicative delivery-option estimate could diverge from the checkout/
 * quote binding-shipping-method basis. The UID-419 amendment retired that note
 * from the CART rail and the GENERATE-QUOTE modal (design-fidelity review
 * against `Fictiv Platform.dc.html`, which carries no such note on either
 * surface) — see the ADR file's "Amendment — UID-419" section for the full
 * rationale and the resulting (intentional) asymmetry with RFQ compose below.
 * Checkout's own note was ALREADY unused before this amendment (design omits
 * it too, per `Fictiv Platform.dc.html:2133-2134` — see
 * `CheckoutSummaryRail.test.tsx`) and has been deleted here for the same
 * "don't keep a copy constant with zero renderers" reason as the two above,
 * rather than kept around with a comment justifying its absence.
 *
 * The one note actually rendered today is `PRICING_RFQ_COMPOSE_NOTE` (RFQ
 * compose rail, via `RepriceNote`, components/ui/RepriceNote.tsx).
 */

/** RFQ compose rail (UID-401, ADR-0125 D5, superseding ADR-0118 D2.1 #4/D2.2)
 * — Shipping and Tax are now REAL, server-derived pre-checkout estimates
 * (keyed on the persisted ship method / resolved ship-to address), included
 * in Total whenever the server can derive them. This note is the honest,
 * non-silent disclosure that they are still an ESTIMATE, not the final
 * checkout figure (ADR-0061) — it must stay true whether or not a given
 * draft currently has a derivable Shipping/Tax figure, so it deliberately
 * does NOT claim either is excluded. Reuses the shared `RepriceNote` mechanism
 * (see the module doc above) rather than an inline qualifier on "Total"
 * itself. */
export const PRICING_RFQ_COMPOSE_NOTE =
  'Shipping and tax reflect your selected method and destination, where available, and are estimates — not the final checkout total.'
